import { render, staticRenderFns } from "./CardsAdmin.vue?vue&type=template&id=48dfa615"
import script from "./CardsAdmin.vue?vue&type=script&lang=js"
export * from "./CardsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports